import {BaseService} from './baseService.js';

/* 
 * Handles interaction with the company api
 */
export class LookupService extends BaseService {
	
	async getLookupTypes(systemTablesOnly) {		
		
		var queryParm = systemTablesOnly ? '?systemTables=' + systemTablesOnly : '';
		var types = await this.makeGETRequest('/api/resource/lookuptypes' + queryParm);
		return types;
	}
	
	async getLookupValues(entity, status, paging) {
		var params = '';		
		var paging = paging || {};
		if (paging) {
			if (status) {
				paging.status = status;
			}
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/lookuptypes/' + entity + '/' + params);
		return data;
	}
	
	async removeLookupValue(entity, code) {
		var success = await this.makeDELETERequest('/api/resource/lookuptypes/' + entity + '/' + encodeURIComponent(code));
	}

	async saveLookupValue(entity, lookupCode) {
		var code;
		if (lookupCode.editMode) {
			code = await this.makePUTRequest('/api/resource/lookuptypes/' + entity + '/' + encodeURIComponent(lookupCode.code), lookupCode);
		} else {
			code = await this.makePOSTRequest('/api/resource/lookuptypes/' + entity, lookupCode);
		}
		return code;
	}
	
	async activateLookupValue(entity, code) {
		var activeCode = await this.makePUTRequest('/api/resource/lookuptypes/' + entity + '/' + encodeURIComponent(code) + '/activate');
		return activeCode; 
	}

};


